import type { FC, ReactNode } from 'react'

import { Suspense } from 'react'
import ConditionallyRender from '@/components/ConditionallyRender'

import { useStartNftSaleMachine } from '../atoms/nftSaleMachineAtom'

const ClientSideOnly: FC<{children: ReactNode}> = ({ children }) => {
  useStartNftSaleMachine()
  return (
    <Suspense>
      {children}
    </Suspense>
  )
}

export default function WithNftSaleMachine({ children }: { children: ReactNode }) {
  return (
    <ConditionallyRender client>
      <ClientSideOnly>
        {children}
      </ClientSideOnly>
    </ConditionallyRender>
  )
}
